require('../bootstrap');

import { createApp } from 'vue';
import UserApp from './components/UserApp.vue'
import router from './router'

createApp(UserApp).use(router).mount("#app")
